<template>
  <v-card class="dialog dialogHistorico">
    <v-card-title class="primary">
      <h3 class="headline text-uppercase ">Status Apolice Rejeitada</h3>
    </v-card-title>
    <v-card-text class="py-5 px-4">
      <v-layout>
        <pre v-if="descricoes && descricoes.charAt(0) == '{'">{{ descricoes }}</pre>
        <p v-else>{{ descricoes }}</p>
      </v-layout>
    </v-card-text>
    <v-card-actions class="px-5 pb-5">
      <v-flex class="text-xs-right">
        <v-btn
          class="fechar-dialog elevation-0"
          @click="fecharDialogHistoricoErro"
        >
          Fechar
        </v-btn>
      </v-flex>
    </v-card-actions>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Fechar</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "ModalHistoricoErro",
  data: () => ({
    snack: null,
    snackText: null,
    snackColor: null,
    descricoes: null,
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },
    historicoDados: []
  }),
  props: {
    idApolice: Number,
    endosso: {
      type: Boolean,
      default: false
    },
    cotacao: {
      type: Boolean,
      default: false
    },
    uuidRevisao: String,
    idRascunho: Number,
    numeroProposta: String,
    idStatus: Number,
    numeroRevisao: Number
  },
  mounted() {
    if (this.cotacao == true) {
      this.buscarJsonErroRespostaEssor();
    } else if (this.endosso == true) {
      this.buscarJsonErroEndossoRespostaEssor();
    }
  },
  computed: {
    descricaoFormatada() {
      try {
        return JSON.stringify(JSON.parse(this.descricoes), null, 2);
      } catch (error) {
        console.log(error, this.descricoes);
        return "";
      }
    }
  },

  methods: {
    fecharDialogHistoricoErro() {
      this.$emit("fecharDialogHistoricoErro");
    },

    buscarJsonErroRespostaEssor() {
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/buscarJsonErroRespostaEssor/${this.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.descricoes = JSON.stringify(response.data, null, 2);
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Relatório de erro não encontrado";
        });
    },

    buscarJsonErroEndossoRespostaEssor() {
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/buscarJsonErroEndossoRespostaEssor/${this.numeroRevisao}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.descricoes = JSON.stringify(response.data, null, 2);
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Relatório de erro não encontrado";
        });
    }
  }
};
</script>

<style>
.dialogHistorico .table-grid thead {
  background-color: transparent;
}
.dialogHistorico .table-grid .column {
  color: #333333 !important;
}
.dialogHistorico .theme--light.v-table {
  background-color: transparent;
}
.dialogHistorico .theme--light.v-table tbody tr {
  border: 0;
}
.dialogHistorico
  .theme--light.v-table
  tbody
  tr:hover:not(.v-datatable__expand-row) {
  background-color: transparent;
}
.dialogHistorico .theme--light.v-table tbody tr p {
  margin-bottom: 0;
}
.dialogHistorico table.v-table tbody td {
  height: 26px;
}
.dialogHistorico .theme--light.v-table thead tr:first-child {
  border: 0;
}
.dialogHistorico table.v-table thead tr {
  height: 26px;
}
.dialogHistorico .dialogHistorico .table-grid .column {
  font-weight: bold;
}
.dialogHistorico table.v-table tbody td:first-child {
  padding: 0;
}
.dialogHistorico table.v-table thead th:first-child {
  padding: 0;
}
.dialogHistorico .border-separador {
  border-bottom: 1px solid #d7d7d7;
  margin: 20px 0;
  display: block;
  width: 100%;
}
.dialogHistorico .error-headline {
  color: #333333;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 10px;
}
.dialogHistorico .headline {
  padding-left: 8px;
  color: #fff;
  font-size: 14px;
}

.dialogHistorico .fechar-dialog {
  color: #00466e;
  box-shadow: 0 !important;
  border: 0;
}
.dialogHistorico .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  box-shadow: 0 !important;
}
.dialogHistorico .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: transparent;
  box-shadow: 0 !important;
}
.textErrorScroll {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalHistoricoErro.vue